<template>
  <main-sidebar
    :name="name"
    :title="expense.ShortName || 'No Asignado'"
    size="large"
    v-model="isSidebarActive"
    :titleStyle="{ 'background-color': background, color: 'white' }"
  >
    <div :id="`loading-${this.name}-sidebar`" class="vs-con-loading__container">
      <div class="text-left text-white">
        <vs-row
          vs-justify="center"
          class="px-4 pb-4"
          :style="{ 'background-color': background }"
        >
          <!-- <vs-col vs-type="flex">
            <span class="font-18">{{ expense.ShortName }}</span>
          </vs-col> -->
          <vs-col vs-type="flex" vs-w="12">
            Expense Id: {{ expense.ExpenseId }}</vs-col
          >
          <vs-col vs-type="flex" vs-w="12"> Serie:SG </vs-col>
          <vs-col vs-type="flex" vs-w="12"> Folio:{{ expense.Folio }} </vs-col>
          <vs-col vs-type="flex" :vs-w="expense.StatusId == 7 ? '5' : '12'">
            Date:{{ expense.ExpenseDate }}
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-offset="1"
            vs-w="6"
            v-if="expense.StatusId == 7"
            vs-justify="flex-end"
            vs-align="flex-end"
          >
            {{ $t('paid') }} {{ formatDate(expense.PaidJournalDate) }}
            {{ expense.payment_method != null ? expense.payment_method : '' }}
            ID:{{ expense.PaidJournalNumber }}
          </vs-col>
        </vs-row>
      </div>
      <vs-row vs-justify="flex-start">
        <vs-col vs-type="flex" vs-xs="12" vs-sm="3" vs-lg="3">
          <expense-pdf-viewer
            class="w-full m-2"
            :expense="expense_id"
            :title="`${expense.ShortName} | ${expense.Folio} | ${expense.ExpenseDate}`"
            :disabled="docs.length === 0"
          />
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-xs="12"
          vs-sm="2"
          vs-lg="2"
          v-if="expense.StatusId === '13'"
        >
          <vs-button
            icon-pack="feather"
            icon="icon-corner-up-left"
            color="warning"
            type="filled"
            class="w-full m-2"
            @click="openModalClasificate = true"
          >
            {{ $t('classify') | capitalize }}
          </vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-xs="12"
          vs-sm="3"
          vs-lg="3"
          v-if="expense.StatusId !== '10' && expense.StatusId !== '13'"
        >
          <upload-file
            v-model="files"
            multiple
            btnType="filled"
            btnColor="success"
            class="w-full m-2"
            :btnText="$t('upload_file') | capitalize"
            accept="application/pdf"
            v-if="expense.StatusId !== '10' && expense.StatusId !== '13'"
            @input="uploadFile"
          />
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-xs="12"
          vs-sm="2"
          vs-lg="2"
          v-if="
            expense.StatusId === '0' ||
            (expense.StatusId === '12' && [
              'IU ACCOUNTING APPROVE NEGATIVE EXPENSE',
            ])
          "
        >
          <vs-button
            icon-pack="feather"
            icon="icon-corner-up-left"
            color="warning"
            type="filled"
            class="w-full m-2"
            @click="confirmPending"
          >
            {{ $t('pending') | capitalize }}
          </vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-xs="12"
          vs-sm="2"
          vs-lg="2"
          v-if="
            expense.StatusId === '0' ||
            expense.StatusId === '1' ||
            expense.StatusId === '2' ||
            expense.StatusId === '13'
          "
        >
          <vs-button
            icon-pack="feather"
            icon="icon-trash"
            color="danger"
            type="filled"
            class="w-full m-2"
            @click="commentDeleteActive = true"
          >
            {{ $t('delete') }}
          </vs-button>
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-xs="12"
          vs-sm="2"
          vs-lg="2"
          v-if="expense.StatusId === '1' || expense.StatusId === '2'"
        >
          <vs-button
            icon-pack="feather"
            icon="icon-corner-up-left"
            color="warning"
            type="filled"
            class="w-full m-2"
            @click="commentRejectActive = true"
          >
            {{ $t('reject') }}
          </vs-button>
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-xs="12"
          vs-sm="2"
          vs-lg="2"
          v-if="
            hasPermission(['IU ACCOUNTING PDF SIGN']) && expense.StatusId == 2
          "
        >
          <vs-button
            icon-pack="feather"
            icon="icon-edit-1"
            color="#7367F0"
            type="filled"
            class="w-full m-2 vs-con-loading__container"
            @click="confirmSigned()"
            ref="signButton"
            id="sign-button"
          >
            {{ $t('sign') }}
          </vs-button>
        </vs-col>
      </vs-row>

      <vs-row vs-justify="flex-start">
        <vs-col
          vs-type="flex"
          vs-xs="12"
          vs-sm="3"
          vs-lg="3"
          v-if="
            hasPermission(['IU ACCOUNTING APPORTIONMENT']) &&
            expense.StatusId == 1 &&
            filterClients.length > 1
          "
        >
          <vs-button
            icon-pack="feather"
            icon="icon-git-branch"
            color="#b4764f"
            type="filled"
            class="w-full m-2 vs-con-loading__container"
            @click="apportionmentOpen"
            ref="apportionmentButton"
            id="apportionment-button"
          >
            {{ $t('apportionment') | capitalize }}
          </vs-button>
        </vs-col>
      </vs-row>
      <!-- <div class="" v-if="filterClients.length > 1">
        <vs-button
              icon-pack="feather"
              icon="icon-git-branch"
              color="#b4764f"
              type="filled"
              class=" m-2 vs-con-loading__container"
              ref="apportionmentButton"
              id="apportionment-button"
              v-if="expense.StatusId === '1'"
              @click="apportionmentOpen"
            >
              {{ $t('apportionment') }}
        </vs-button>
      </div> -->
      <vs-row vs-justify="flex-start">
        <vs-col
          vs-type="flex"
          vs-xs="12"
          vs-sm="3"
          vs-lg="3"
          v-if="expense.file !== null"
        >
          <pdf-viewer
            :files="[{ name: 'Payment', pdf: storeUrl + expense.file }]"
            color="#3498DB"
            btnClass="w-full m-2"
            :btnText="$t('show_payment')"
            class="w-full"
            :title="`${expense.ShortName} | ${expense.Folio} | ${expense.ExpenseDate}`"
          />
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-xs="12"
          vs-sm="4"
          vs-lg="4"
          v-if="
            expense.payment_id != null && hasPermission(['IU ACCOUNTING EDIT'])
          "
        >
          <update-payment-file
            class="w-full m-2"
            :expense="expense_id"
            @success="getExpense"
          />
        </vs-col>
      </vs-row>

      <div class="px-2">
        <vs-row class="m-2 py-1" type="flex">
          <vs-col vs-xs="12" vs-sm="1" vs-lg="10">
            <span class="text-custom"
              >{{ $t('pay_date') }}: {{ formatDate(expense.PayDate) }}</span
            >
            <span class="pl-4">
              <feather-icon
                icon="EditIcon"
                v-if="
                  hasPermission(['IU ACCOUNTING EDIT']) &&
                  this.expense.StatusId == '2'
                "
                svgClasses="h-5 w-5 mr-4 hover:text-primary text-warning cursor-pointer"
                @click="openPayDateModal"
              />
            </span>
          </vs-col>
        </vs-row>
      </div>

      <div class="px-2">
        <vs-row class="m-2 py-1">
          <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
            <p>
              <span class="text-custom"
                >{{ $t('client') }}:
                {{ expense.ClientName || 'No Asignado' }}
                <feather-icon
                  icon="UserPlusIcon"
                  svgClasses="h-5 w-5 mr-4 hover:text-primary text-info cursor-pointer"
                  v-if="
                    expense.StatusId === '1' ||
                    expense.StatusId === '2' ||
                    expense.StatusId === '13' ||
                    hasPermission(['IU BUDGET DEPARTAMENT'])
                  "
                  @click="openClientModal"
                />
              </span>
            </p>
          </vs-col>
        </vs-row>
         <vs-row class="m-2 py-1" v-if="expense.ClientId == '19' || expense.ClientId == '62' || expense.ClientId == '122'">
          <vs-col
            vs-xs="12"
            vs-sm="6"
            vs-lg="6"
            
          >
            <p>
              <span class="text-custom"
                >{{ $t('departament') | capitalize }}: </span
              >{{ departament_name || 'No Asignado' }}
            </p>
          </vs-col>
        </vs-row>
        <vs-row class="m-2 py-1">
          <vs-col vs-xs="12" vs-sm="6" vs-lg="6">
            <p>
              <span class="text-custom"
                >{{ $t('account_number') }}:
                {{ accountNumber || 'No Asignado' }}
              </span>
            </p>
          </vs-col>
          <vs-col vs-xs="12" vs-sm="5" vs-lg="5">
            <p>
              <span class="text-custom">{{ $t('category') }}</span
              >: {{ expense.CategoryName }}
            </p>
          </vs-col>
          <vs-col vs-xs="12" vs-sm="1" vs-lg="1">
            <feather-icon
              icon="EditIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary text-warning cursor-pointer"
              @click="openModal"
              v-if="
                hasPermission(['IU ACCOUNTING EDIT']) &&
                (expense.StatusId === '1' ||
                  expense.StatusId === '2' ||
                  expense.StatusId === '13')
              "
            />
          </vs-col>
        </vs-row>
      </div>

      <div class="px-2">
        <vs-row class="m-2">
          <vs-col class="sm:w-1/2 w-full">
            <strong class="black-color">{{ expense.ClientName }}</strong>
          </vs-col>
          <vs-col class="sm:w-1/2 w-full">
            <strong class="black-color">{{ expense.VendorName }}</strong>
          </vs-col>
        </vs-row>
       




        <vs-row class="m-2">
          <vs-col class="sm:w-1/2 w-full">
            <label class="black-color">{{
              company.CompanyName ||
              'No Proporcionado' + ' ' + company.AddressNumber ||
              'No Proporcionado'
            }}</label>
          </vs-col>
          <vs-col class="sm:w-1/2 w-full">
            <label class="black-color"
              >RFC: {{ vendorInfo.RFC || 'No Proporcionado' }}</label
            >
          </vs-col>
        </vs-row>
        <vs-row class="m-2">
          <vs-col class="sm:w-1/2 w-full">
            <label class="black-color">{{
              company.Address1 ||
              'No Proporcionado' + ' ' + company.AddressNumber ||
              'No Proporcionado'
            }}</label>
          </vs-col>
          <vs-col class="sm:w-1/2 w-full">
            <label class="black-color"
              >Ciudad,Estado CP :
              {{ expense.AddressCity || 'No Proporcionado' }},{{
                expense.AddressZip || 'No Proporcionado'
              }}</label
            >
          </vs-col>
        </vs-row>
        <vs-row class="m-2">
          <vs-col class="sm:w-1/2 w-full">
            <label class="black-color">{{
              (company.AddressCity || 'No Proporcionado') +
                ' ' +
                company.AddressZip || 'No Proporcionado'
            }}</label>
          </vs-col>
          <vs-col class="sm:w-1/2 w-full">
            <vs-col vs-xs="12" vs-sm="1" vs-lg="10">
              <label class="black-color"
                >Email: {{ vendorInfo.Email || 'No Proporcionado' }}</label
              >
            </vs-col>
            <vs-col vs-xs="12" vs-sm="1" vs-lg="2">
              <feather-icon
                icon="EditIcon"
                svgClasses="h-5 w-5 mr-4 hover:text-primary text-warning cursor-pointer"
                v-if="expense.StatusId !== '10' && expense.StatusId !== '13'"
                @click="openModalEmail"
              />
            </vs-col>
          </vs-col>
        </vs-row>
        <vs-row class="m-2">
          <vs-col class="sm:w-1/2 w-full">
            <label class="black-color">{{
              company.AddressState || 'No Proporcionado'
            }}</label>
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-table class="m-2" :data="options">
            <template slot="header"> </template>
            <template slot="thead">
              <vs-th> # </vs-th>
              <vs-th>
                {{ $t('description') }}
              </vs-th>
              <vs-th>
                {{ $t('quantity') }}
              </vs-th>
              <vs-th>
                {{ $t('unit_cost') }}
              </vs-th>
              <vs-th>
                {{ $t('total') }}
              </vs-th>
            </template>
            <template>
              <vs-tr :key="indextr" v-for="(tr, indextr) in items">
                <vs-td :style="{ width: '3vw' }">
                  {{ items[indextr].ItemId }}
                </vs-td>
                <vs-td
                  :style="{ width: '35vw' }"
                  v-html="items[indextr].Description"
                >
                </vs-td>
                <vs-td :style="{ width: '10vw' }">
                  {{ formatNumber(items[indextr].Quantity) }}
                </vs-td>
                <vs-td :style="{ width: '10vw' }" class="text-right">
                  $
                  {{
                    formatNumber(
                      parseFloat(items[indextr].UnitPrice).toFixed(2),
                      2
                    )
                  }}
                </vs-td>
                <vs-td :style="{ width: '10vw' }" class="text-right">
                  $
                  {{
                    formatNumber(
                      parseFloat(items[indextr].Amount).toFixed(2),
                      2
                    )
                  }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-row>

        <vs-row>
          <vs-col
            vs-xs="12"
            vs-md="5"
            vs-lg="5"
            vs-offset="1"
            style="color: #6495ed"
          >
            <vs-row>
              <vs-col>
                <span
                  >Sub-Total: $ {{ formatNumber(expense.Subtotal, 2) }}
                </span>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col>
                <span
                  >{{ $t('tax') }}: $ {{ formatNumber(expense.IVA, 2) }}
                </span>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col>
                <span
                  ><strong
                    >{{ $t('requested_amount') }}: $
                    {{
                      formatNumber(
                        Number(expense.Subtotal) + Number(expense.IVA),
                        2
                      )
                    }}
                  </strong></span
                >
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-xs="12" vs-md="3" vs-lg="3" vs-offset="3">
            <vs-row>
              <vs-col>
                <span class="black-color"
                  >{{ $t('currency') }}: {{ expense.CurrencyId }}
                </span>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col>
                <span class="black-color"
                  >Sub-Total: $ {{ formatNumber(expense.Subtotal, 2) }}
                </span>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col>
                <span class="black-color"
                  >{{ $t('tax') }}: $ {{ formatNumber(expense.IVA, 2) }}
                </span>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col>
                <span class="black-color"
                  >{{ $t('retained_iva') }}: $
                  {{ formatNumber(expense.RetainedIva, 2) }}
                </span>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col>
                <span class="black-color"
                  >{{ $t('retained_isr') }}: $
                  {{ formatNumber(expense.RetainedISR, 2) }}
                </span>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col>
                <span class="black-color"
                  ><strong
                    >Total: $ {{ formatNumber(expense.totalxml, 2) }}</strong
                  >
                </span>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>

      <log-detail :statusId="expense.StatusId" :logs="logs" />

      <div class="mt-4">
        <vs-row vs-w="12">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mx-4">
            <comments :data="comments" @send="addComment" class="w-full" />
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" >
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mx-4">
            <expense-attachment :expense_id="expense_id" ref="expenseAttachments" @update="getComments"/>
          </vs-col>
        </vs-row>
      </div>
      

      <vs-popup
        classContent="popup-custom"
        :title="$t('apportionment')"
        :active.sync="apportionment"
      >
        <vs-row class="w-full">
          <vs-col class="w-1/3">
            <span class="black-color"
              >{{ $t('currency') }}: {{ expense.CurrencyId }}
            </span>
          </vs-col>
          <vs-col class="w-1/3">
            <span class="black-color"
              >Sub-Total: $
              {{ formatNumber(parseFloat(expense.Subtotal).toFixed(2), 2) }}
            </span>
          </vs-col>
          <vs-col class="w-1/3">
            <span class="black-color"
              ><strong
                >Total: $
                {{
                  formatNumber(parseFloat(expense.Total).toFixed(4), 4)
                }}</strong
              >
            </span>
          </vs-col>
        </vs-row>

        <vs-row class="mt-3">
          <span class="black-color">{{ $t('category') }} </span>
        </vs-row>
        <vs-row>
          <select
            v-model="aptCategory"
            class="w-full vs-inputx vs-input--input"
          >
            <option
              v-for="(option, i) in options"
              :key="i"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </vs-row>

        <div class="my-2" :key="index" v-for="(data, index) in apportionments">
          <ExpenseApportionmentComponentVue
            :amount="apportionments[index].amount"
            :clients="filterClients"
            :client="apportionments[index].client"
            :percent="apportionments[index].percent"
            :total="expense.Total"
            :index="index"
            @apoortionmentChangeValues="apoortionmentChangeValues"
            @deleteClientApportionment="deleteClientApportionment"
          />
        </div>
        <!-- <vs-row vs-justify="center" vs-align="center" vs-w="12" class="my-2" v-if="filterClients.length > apportionments.length">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-xs="12"
              vs-sm="10"
              vs-lg="10"
            >
            
              <vs-button
                color="success"
                type="filled"
                class="w-full m-2 p-2"
                @click="addClientApportionment()"
                >
                <feather-icon icon="UserPlusIcon" svgClasses="h-5 w-5 mr-4"/>
                {{ $t('add_client') }}
              </vs-button>
            </vs-col>
          </vs-row> -->
        <vs-alert
          :active="
            aptAmountValidate ||
            aptPercentValidate ||
            aptClientValidate ||
            aptClientValidate ||
            aptClientRepet
          "
          color="danger"
          icon="new_releases"
        >
          <ul>
            <li>
              <span v-if="aptAmountValidate == true" class="text-primary">
                {{ $t('amount_invalid') | capitalize }}
              </span>
            </li>
            <li>
              <span v-if="aptPercentValidate == true" class="text-primary">
                {{ $t('percent_invalid') | capitalize }}
              </span>
            </li>
            <li>
              <span v-if="aptClientValidate == true" class="text-primary">
                {{ $t('client_invalid') | capitalize }}
              </span>
            </li>
            <li>
              <span v-if="aptClientRepet == true" class="text-primary">
                {{ $t('client_repeted') | capitalize }}
              </span>
            </li>
            <li>
              <span v-if="aptCategoryValidate == true" class="text-primary">
                {{ $t('category_invalid') | capitalize }}
              </span>
            </li>
          </ul>
        </vs-alert>
        <!-- <h5> <span v-if=" aptAmountValidate == true"  class="text-primary"> {{ $t('amount_invalid') | capitalize}} </span> </h5>
        <h5> <span v-if=" aptPercentValidate == true" class="text-primary"> {{ $t('percent_invalid') | capitalize}} </span> </h5>
        <h5> <span v-if=" aptClientValidate == true"  class="text-primary"> {{ $t('client_invalid') | capitalize}} </span> </h5>
        <h5> <span v-if=" aptClientRepet == true"  class="text-primary"> {{ $t('client_repeted') | capitalize}} </span> </h5>
        <h5> <span v-if=" aptClientRepet == true"  class="text-primary"> {{ $t('category_invalid') | capitalize}} </span> </h5>    -->
        <vs-row class="w-full justify-content-end my-4">
          <vs-col class="w-1/2 px-4">
            <span class="black-color"
              >Total: $
              {{ formatNumber(parseFloat(aptTotal).toFixed(4), 4) }}</span
            >
          </vs-col>
          <vs-col class="w-1/2 px-4">
            <!-- <span class="black-color" ><strong> % {{formatNumber(parseFloat(aptPercent).toFixed(4), 4)}}</strong> </span> -->
            <span class="black-color"
              ><strong> % {{ aptPercent }}</strong>
            </span>
          </vs-col>
        </vs-row>
        <vs-row vs-justify="center" vs-align="center" vs-w="12">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="4"
            vs-lg="4"
          >
            <vs-button
              color="success"
              type="filled"
              class="w-full m-2 p-2"
              @click="addClientApportionment()"
            >
              <feather-icon icon="UserPlusIcon" svgClasses="h-5 w-5 mr-4" />
              {{ $t('add_client') }}
            </vs-button>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="4"
            vs-lg="4"
          >
            <vs-button
              color="primary"
              type="filled"
              class="w-full"
              @click="apportionmentSave()"
              >{{ $t('save') }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-popup>

      <vs-popup
        classContent="popup-custom"
        :title="$t('update_expense')"
        :active.sync="edit"
      >
        <vs-row vs-justify="center" vs-align="center" vs-w="12" class="mb-2">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="4"
            vs-lg="4"
          >
            <label>{{ $t('account_number') }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="8"
            vs-lg="8"
          >
            <vs-input
              :placeholder="$t('account_number')"
              class="w-full"
              autocomplete="off"
              v-model="accountNumber"
            />
          </vs-col>
        </vs-row>
        <vs-row vs-justify="center" vs-align="center" vs-w="12" class="mb-2">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="4"
            vs-lg="4"
          >
            <label>{{ $t('category') }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="8"
            vs-lg="8"
          >
            <!-- <v-select
              :options="options"
              v-model="defaultSelected"
              class="w-full select-custom"
            /> -->

            <select
              v-model="defaultSelected"
              class="w-full vs-inputx vs-input--input"
            >
              <option
                v-for="(option, i) in options"
                :key="i"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </vs-col>
        </vs-row>
        <vs-row vs-justify="flex-end" vs-align="center" vs-w="12">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="2"
            vs-lg="2"
          >
            <vs-button
              color="primary"
              type="filled"
              @click="submitAccount()"
              class="w-full"
              >{{ $t('save') }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-popup>

      <vs-popup
        classContent=""
        :title="$t('comment_reject')"
        :active.sync="commentRejectActive"
        :button-close-hidden="true"
      >
        <vs-row
          vs-justify="center"
          vs-align="center"
          vs-w="12"
          class="mb-2 w-full"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="8"
            vs-lg="8"
            class="w-full"
          >
            <vs-textarea
              :placeholder="$t('add_comment_reject')"
              class="w-full"
              autocomplete="off"
              v-model="commentReject"
            />
          </vs-col>
        </vs-row>
        <vs-row vs-justify="flex-end" vs-align="center" vs-w="12">
          <vs-col
            class="pr-2"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="2"
            vs-lg="2"
          >
            <vs-button
              color="primary"
              type="filled"
              @click="deteleReject()"
              class="w-full"
              v-if="commentReject != null && commentReject != ''"
              >{{ $t('send') | capitalize }}</vs-button
            >
            <vs-button
              color="primary"
              type="filled"
              class="w-full"
              v-else
              disabled
              >{{ $t('send') | capitalize }}</vs-button
            >
          </vs-col>
          <vs-col
            class="pr-2"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="2"
            vs-lg="2"
          >
            <vs-button
              color="gray"
              type="filled"
              vs-align="center"
              @click="closePopUp()"
              class="w-full"
              >{{ $t('cancel') | capitalize }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-popup>

      <vs-popup
        classContent=""
        :title="$t('comment_delete')"
        :active.sync="commentDeleteActive"
        :button-close-hidden="true"
      >
        <vs-row
          vs-justify="center"
          vs-align="center"
          vs-w="12"
          class="mb-2 w-full"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="8"
            vs-lg="8"
            class="w-full"
          >
            <vs-textarea
              :placeholder="$t('add_comment_delete')"
              class="w-full"
              autocomplete="off"
              v-model="commentDelete"
            />
          </vs-col>
        </vs-row>
        <vs-row vs-justify="flex-end" vs-align="center" vs-w="12">
          <vs-col
            class="pr-2"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="2"
            vs-lg="2"
          >
            <vs-button
              color="primary"
              type="filled"
              @click="deteleExpense()"
              class="w-full"
              v-if="commentDelete != null && commentDelete != ''"
              >{{ $t('send') | capitalize }}</vs-button
            >
            <vs-button
              color="primary"
              type="filled"
              class="w-full"
              v-else
              disabled
              >{{ $t('send') | capitalize }}</vs-button
            >
          </vs-col>
          <vs-col
            class="pr-2"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="2"
            vs-lg="2"
          >
            <vs-button
              color="gray"
              type="filled"
              vs-align="center"
              @click="closePopUp()"
              class="w-full"
              >{{ $t('cancel') | capitalize }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-popup>

      <vs-popup
        classContent="popup-custom"
        :title="$t('update_vendor_email')"
        :active.sync="editEmail"
      >
        <vs-row vs-justify="center" vs-align="center" vs-w="12" class="mb-2">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="4"
            vs-lg="4"
          >
            <label>{{ $t('email') }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="8"
            vs-lg="8"
          >
            <vs-input
              autocomplete="off"
              name="email"
              :placeholder="$t('email')"
              class="w-full"
              v-model="vendorEmail"
              v-validate="'email'"
            />
          </vs-col>
        </vs-row>
        <vs-row vs-justify="center" vs-align="center" vs-w="12" class="mb-2">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-offset-sm="4"
            vs-offset-lg="4"
            vs-offset-xs="12"
            vs-sm="8"
            vs-lg="8"
          >
            <span class="text-danger text-sm" v-show="errors.has('email')">{{
              errors.first('email')
            }}</span>
          </vs-col>
        </vs-row>

        <vs-row vs-justify="flex-end" vs-align="center" vs-w="12">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="2"
            vs-lg="2"
          >
            <vs-button
              color="success"
              type="border"
              @click="submitEmail()"
              :disabled="!isEmailFormValid"
              class="w-full"
              >{{ $t('save') }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-popup>

      <vs-popup :title="$t('assign_client')" :active.sync="clientModal">
        <vs-row vs-justify="center" vs-align="center" vs-w="12" class="mb-2">
          <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
            <label>{{ $t('client') }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="12"
            vs-lg="12"
          >
            <select v-model="client" class="w-full vs-inputx vs-input--input">
              <option
                v-for="(option, i) in filterClients"
                :key="i"
                :value="option.ClientId"
              >
                {{ option.ClientName }}
              </option>
            </select>
          </vs-col>
        </vs-row>
        <vs-row vs-justify="center" vs-align="center" vs-w="12" class="mb-2" v-if="client == '19' || client == '62' || client == '122'">
          <vs-col
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="12"
            vs-lg="12"
          >
            <label>{{ $t('departament') }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="12"
            vs-lg="12"
          >
            <select
              v-model="departament"
              class="w-full vs-inputx vs-input--input"
            >
              <option
                v-for="(option, i) in departaments"
                :key="i"
                :value="option.id"
              >
                {{ option.name }}
              </option>
            </select>
          </vs-col>
        </vs-row>
        <vs-row vs-justify="flex-end" vs-align="center" vs-w="12" class="mt-4">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="2"
            vs-lg="2"
          >
            <vs-button
              color="primary"
              type="filled"
              @click="assignClient()"
              class="w-full"
              >{{ $t('save') }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-popup>

      <vs-popup
        :title="$t('assign') + ' ' + $t('pay_date')"
        :active.sync="openModalPayDate"
      >
        <vs-row vs-justify="center" vs-align="center" vs-w="12" class="mb-2">
          <vs-col vs-type="flex" vs-xs="12" vs-sm="12" vs-lg="12">
            <label>{{ $t('pay_date') }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="12"
            vs-lg="12"
          >
            <select
              v-model="selectedPayDate"
              class="w-full vs-inputx vs-input--input"
              :disabled="disabledSubmitPayDate"
            >
              <option
                v-for="(option, i) in payDateOptions"
                :key="i"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </vs-col>
        </vs-row>
        <vs-row vs-justify="flex-end" vs-align="center" vs-w="12" class="mt-4">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="2"
            vs-lg="2"
          >
            <vs-button
              color="primary"
              type="filled"
              class="w-full"
              :disabled="disabledSubmitPayDate"
              @click="submitPayDate"
              >{{ $t('save') }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-popup>


      <vs-popup
        :title="$t('classify') | capitalize"
        :active.sync="openModalClasificate"
      >
        <vs-row vs-justify="center" vs-align="center" vs-w="12" class="mb-2">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="4"
            vs-lg="4"
          >
            <label>{{ $t('account_number') }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="8"
            vs-lg="8"
          >
            <vs-input
              :placeholder="$t('account_number')"
              class="w-full"
              autocomplete="off"
              v-model="accountNumber"
            />
          </vs-col>
        </vs-row>
        <vs-row vs-justify="center" vs-align="center" vs-w="12" class="mb-2">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="4"
            vs-lg="4"
          >
            <label>{{ $t('category') }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="8"
            vs-lg="8"
          >
            <select
              v-model="defaultSelected"
              class="w-full vs-inputx vs-input--input"
            >
              <option
                v-for="(option, i) in options"
                :key="i"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </vs-col>
        </vs-row>

        <vs-row vs-justify="center" vs-align="center" vs-w="12" class="mb-2">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="4"
            vs-lg="4"
          >
            <label>{{ $t('client') }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="8"
            vs-lg="8"
          >
            <select v-model="client" class="w-full vs-inputx vs-input--input">
              <option
                v-for="(option, i) in filterClients"
                :key="i"
                :value="option.ClientId"
              >
                {{ option.ClientName }}
              </option>
            </select>
          </vs-col>
        </vs-row>
        <vs-row vs-justify="flex-end" vs-align="center" vs-w="12" class="mt-4">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="2"
            vs-lg="2"
          >
            <vs-button
              color="primary"
              type="filled"
              class="w-full"
              :disabled="disabledSubmitPayDate"
              @click="rejectClasification"
              >{{ $t('save') }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-popup>
      <!--  <pay-date-modal :active="openModalPayDate" /> -->
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import UploadFile from '@/views/components/UploadFile.vue'
import PdfViewer from '@/views/components/PdfViewer.vue'
import Comments from '@/views/components/Comments.vue'
import vSelect from 'vue-select'
import validate from '@/mixins/Validate.js'
import expense from '@/http/requests/expense'
import accounting from '@/http/requests/accounting'
import client from '@/http/requests/client'
import notification from '@/http/requests/notification'
import ExpenseApportionmentComponentVue from './ExpenseApportionmentComponent.vue'

import moduleExpense from '@/store/expense/moduleExpense.js'
import UpdatePaymentFile from '@/views/apps/expense/components/UpdatePaymentFile.vue'
import ExpensePdfViewer from '@/views/apps/accounting/components/ExpensePdfViewer'

import PayDateModal from './PayDateModal.vue'
import LogDetail from './LogDetail.vue'
import moment from 'moment'

import { BASE_URL } from '@/urls.js'

import ExpenseAttachment from '@/views/apps/expense/components/ExpenseAttachment/ExpenseAttachment.vue'

export default {
  mixins: [validate],
  components: {
    MainSidebar,
    UploadFile,
    PdfViewer,
    Comments,
    vSelect,
    UpdatePaymentFile,
    ExpensePdfViewer,
    PayDateModal,
    LogDetail,
    ExpenseApportionmentComponentVue,
    ExpenseAttachment
  },
  props: ['expense_id'],
  data() {
    return {
      submitButtonText: this.$i18n.messages[this.$i18n.locale].save,
      name: 'expense-detail',
      expense: {
        payment_id: null,
        ShortName: null,
        Folio: null,
        ReceivedDate: null,
      },
      files: [],
      storeUrl: `${BASE_URL}storage/`,
      comments: [],
      docs: [],
      loading: {
        files: false,
        comments: false,
        expense: false,
        clients: false,
        submit: false,
        logs: false,
        departaments: false,
      },
      options: [],
      company: {
        CompanyName: '',
        Address1: '',
        AddressNumber: '',
        AddressCity: '',
        AddressZip: '',
        AddressState: '',
      },
      items: {},
      vendorInfo: {},
      defaultSelected: [],
      departaments: [],
      departament_name: '',
      departament: '',
      accountNumber: '',
      total: 0,
      tax: 0,
      subtotal: 0,
      background: '',
      vendorEmail: '',
      edit: false,
      editEmail: false,
      showSidelist: false,
      clientModal: false,
      openModalPayDate: false,
      openModalClasificate: false,
      disabledSubmitPayDate: false,
      clients: [],
      payDateOptions: [],
      selectedPayDate: '',
      client: '',
      commentReject: null,
      commentDelete: null,
      commentRejectActive: false,
      commentDeleteActive: false,
      logs: [],
      apportionment: false,
      apportionments: [],
      aptAmountValidate: false,
      aptPercentValidate: false,
      aptClientValidate: false,
      aptClientRepet: false,
      aptCategoryValidate: false,
      aptCategory: '',
      aptTotal: 0.0,
      aptPercent: 0.0,
    }
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return (
        this.loading.files ||
        this.loading.comments ||
        this.loading.expense ||
        this.loading.clients ||
        this.loading.logs ||
        this.loading.departaments ||
        this.loading.submit
      )
    },
    isEmailFormValid() {
      return !this.errors.any()
    },
    filterClients() {
      return this.clients.filter(
        (client) => client.CompanyId == this.expense.CompanyId
      )
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading()
      } else {
        this.closeLoading()
      }
    },
    apportionment(val) {
      if (val == false) {
        this.apportionments = []
        this.aptAmountValidate = false
        this.aptPercentValidate = false
        this.aptClientValidate = false
        this.aptClientRepet = false
        this.aptCategoryValidate = false
        this.aptCategory = ''
        this.aptTotal = 0.0
        this.aptPercent = 0.0
      }
    },
  },
  created() {
    if (!moduleExpense.isRegistered) {
      this.$store.registerModule('expense', moduleExpense)
      moduleExpense.isRegistered = true
    }
  },
  methods: {
    init() {
      this.getExpense()
      this.getClients()
      this.getLogs()
      this.getDepartaments()
      this.edit = false
    },
    expenseInfo() {
      this.loading.expense = true
      accounting
        .ExpenseData(this.expense_id)
        .then((res) => {
          this.total = 0
          this.vendorInfo = res.data.vendor
          this.company = res.data.company
          // this.options = res.data.categories
          this.options = []

          let categories = []
          categories = res.data.categories

          if (this.$i18n.locale === 'es') {
            for (let i = 0; i < categories.length; i++) {
              this.options.push({
                value: categories[i].value,
                label: categories[i].labelSp,
              })
            }
          } else {
            for (let i = 0; i < categories.length; i++) {
              this.options.push({
                value: categories[i].value,
                label: categories[i].label,
              })
            }
          }
          this.getItems(res.data.items)
          this.loading.expense = false
        })
        .catch((res) => {
          this.close()
          this.loading.expense = false
        })
    },
    getItems(items) {
      this.items = items
      this.items.forEach((element) => {
        this.total += this.convertStringFloat(element.Amount)
      })
    },
    convertStringFloat(value) {
      const convert = +value
      return convert
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    openLoading() {
      this.$vs.loading({
        container: `#loading-${this.name}-sidebar`,
        scale: 0.6,
      })
    },
    closeLoading() {
      this.$vs.loading.close(`#loading-${this.name}-sidebar > .con-vs-loading`)
    },
    submitEmail() {
      this.editEmail = false
      this.loading.submit = true
      const value = this.defaultSelected
      const form = new FormData()
      form.append('vendor_id', this.vendorInfo.VendorId)
      form.append('email', this.vendorEmail)

      this.$store
        .dispatch('expense/updateVendorEmail', form)
        .then((res) => {
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Vendor Updated',
          })
          this.vendorInfo.Email = res.data.item.Email
          this.loading.submit = false
        })
        .catch((res) => {
          this.loading.submit = false
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
        })
    },
    submitPayDate() {
      this.disabledSubmitPayDate = true
      let params = {
        ExpenseId: this.expense.ExpenseId,
        PayDate: this.selectedPayDate,
      }
      expense
        .updatePayDate(params)
        .then((res) => {
          this.getExpense()
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: res.data.message,
          })
          this.openModalPayDate = false
          this.disabledSubmitPayDate = false
        })
        .catch((err) => {
          this.openModalPayDate = false
          this.disabledSubmitPayDate = false
        })
    },
    addComment(text) {
      this.loading.comments = true
      expense
        .addComment({ expense_id: this.expense_id, comment: text })
        .then((res) => {
          this.comments = [...this.comments, res.data.item]
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Item Added',
          })
          this.loading.comments = false
        })
        .catch((res) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.loading.comments = false
        })
    },
    getComments() {
      this.loading.comments = true
      expense
        .getComments({ expense_id: this.expense_id })
        .then((res) => {
          this.comments = res.data.comments
          this.loading.comments = false
        })
        .catch((res) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.loading.comments = false
        })
    },
    getFiles() {
      this.loading.files = true
      expense
        .getFiles({ expense_id: this.expense_id })
        .then((res) => {
          this.docs = res.data.files
          this.loading.files = false
        })
        .catch((res) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.loading.files = false
        })
    },
    getPayDateOptions() {
      let options = []
      for (let i = 0; i < 5; i++) {
        options[i] = {
          value: moment().isoWeekday(5).add(i, 'weeks').format('YYYY-MM-DD'),
          label: moment().isoWeekday(5).add(i, 'weeks').format('MM/DD/YYYY'),
        }
      }
      this.payDateOptions = options
      this.selectedPayDate = this.payDateOptions[0].value
    },
    uploadFile() {
      this.loading.files = true
      const data = new FormData()
      data.append('expense_id', this.expense_id)
      this.files.forEach(function (file, i) {
        data.append('files[]', file)
      })
      expense
        .uploadFile(data)
        .then((res) => {
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Uploaded File',
          })
          this.loading.files = false
          this.getFiles()
          this.files = []
        })
        .catch((err) => {
          if (422 === err.response.status) {
            const errors = err.response.data.errors
            const errorArray = Object.keys(errors).map(function (key) {
              return [key, errors[key]]
            })
            errorArray.forEach((element) => {
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: element[1][0],
              })
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Alert',
              text: 'SERVER ERROR',
            })
          }
          this.loading.files = false
          this.files = []
        })
    },
    sign() {
      this.$vs.loading({
        container: '#sign-button',
        scale: 0.45,
      })
      expense
        .signedManual({ id: this.expense_id, update: true })
        .then((res) => {
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Expense Signed',
          })
          this.getExpense()
          this.$vs.loading.close('#sign-button > .con-vs-loading')
        })
        .catch((res) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.$vs.loading.close('#sign-button > .con-vs-loading')
        })
    },
    confirmSigned() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$i18n.messages[this.$i18n.locale].sign_pdf,
        text: this.$i18n.messages[this.$i18n.locale]
          .confirm_sign_expense_message,
        acceptText: this.$i18n.messages[this.$i18n.locale].sign_pdf,
        cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
        accept: this.sign,
      })
    },
    toggleEdit() {
      this.edit = !this.edit
    },
    getExpense() {
      this.loading.expense = true
      expense
        .getDetail({ expense_id: this.expense_id })
        .then((res) => {
          this.getComments()
          this.expenseInfo()
          this.getFiles()
          this.readComment()
          this.$refs.expenseAttachments.getAttachments()
          this.expense = res.data.expense
          this.background = this.expense.color
          this.getLogs()
          if (this.expense.color === null) {
            this.background = 'grey'
          }
          this.accountNumber = this.expense.AccountNumber
          this.defaultSelected = this.expense.CategoryId
          this.departament_name = res.data.expense.departament_name
          this.departament = res.data.expense.departament_budget_id == null ? '' : res.data.expense.departament_budget_id
          this.loading.expense = false
        })
        .catch((res) => {
          this.close()
          this.loading.expense = false
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
        })
    },
    readComment() {
      notification
        .readComment({ expense_id: this.expense_id })
        .then((res) => this.$store.dispatch('getNotificationComment'))
    },
    confirmDelete() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$i18n.messages[this.$i18n.locale].confirm,
        text: this.$i18n.messages[this.$i18n.locale].confirm_message,
        acceptText: this.$i18n.messages[this.$i18n.locale].submit,
        cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
        accept: this.deteleExpense,
      })
    },
    deteleExpense() {
      this.loading.expense = true
      expense
        .delete({ expense_id: this.expense_id, comment: this.commentDelete })
        .then((res) => {
          this.loading.expense = false
          this.getExpense()
          this.$emit('refresh-table')
          this.commentDelete = null
        })
        .catch((res) => {
          this.close()
          this.loading.expense = false
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.commentDelete = null
        })
      this.commentDeleteActive = false
    },
    deteleReject() {
      this.loading.expense = true
      expense
        .reject({ expense_id: this.expense_id, comment: this.commentReject })
        .then((res) => {
          this.loading.expense = false
          this.getExpense()
          this.$emit('refresh-table')
          this.commentReject = null
        })
        .catch((res) => {
          this.close()
          this.loading.expense = false
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.commentReject = null
        })
      this.commentRejectActive = false
    },
    closePopUp() {
      this.commentReject = null
      this.commentRejectActive = false

      this.commentDelete = null
      this.commentDeleteActive = false
    },
    confirmPending() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$i18n.messages[this.$i18n.locale].confirm,
        text: this.$i18n.messages[this.$i18n.locale].confirm_message,
        acceptText: this.$i18n.messages[this.$i18n.locale].submit,
        cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
        accept: this.pendingExpense,
      })
    },
    pendingExpense() {
      this.loading.expense = true
      expense
        .pending({ expense_id: this.expense_id })
        .then((res) => {
          this.loading.expense = false
          this.getExpense()
          this.$emit('refresh-table')
        })
        .catch((res) => {
          this.close()
          this.loading.expense = false
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
        })
    },
    openModal() {
      this.edit = true
    },
    openModalEmail() {
      this.vendorEmail =
        this.vendorInfo.Email != null ? this.vendorInfo.Email : ''
      this.editEmail = true
    },
    openPayDateModal() {
      this.getPayDateOptions()
      this.openModalPayDate = true
    },
    openSideList() {
      this.showSidelist = true
    },
    openClientModal() {
      this.client =
        this.expense.ClientId !== null ? this.expense.ClientId : null
      this.clientModal = true
    },
    getClients() {
      this.loading.clients = true
      client
        .list()
        .then((res) => {
          this.loading.clients = false
          this.clients = res.data.clients
        })
        .catch((res) => {
          this.loading.clients = false
        })
    },
    assignClient() {
      this.clientModal = false
      this.loading.submit = true
      let data = {
        client: this.client,
        expense: this.expense_id,
        departament:this.departament
      }
      this.$store
        .dispatch('expense/update', data)
        .then((res) => {
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Updated Expense',
          })
          this.loading.submit = false
          this.getExpense()
        })
        .catch((err) => {
          this.loading.submit = false

          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
        })
    },
    submitAccount() {
      this.edit = false
      this.loading.submit = true
      let data = {
        expense: this.expense_id,
        account: this.accountNumber,
        category: this.defaultSelected
      }
      this.$store
        .dispatch('expense/update', data)
        .then((res) => {
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Updated Expense',
          })
          this.loading.submit = false
          this.getExpense()
        })
        .catch((err) => {
          this.loading.submit = false
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
        })
    },
    rejectClasification() {
      this.loading.expense = true
      let data = {
        expense_id: this.expense_id,
        account: this.accountNumber,
        category: this.defaultSelected,
        client: this.client,
      }
      expense
        .rejectClasification(data)
        .then((res) => {
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Updated Expense',
          })
          this.loading.expense = false
          this.getExpense()
          this.$emit('refresh-table')
        })
        .catch((err) => {
          this.loading.expense = false
          this.displayErrors(err)
          this.openModalClasificate = false
        })
      this.openModalClasificate = false
    },
    getLogs() {
      this.logs = []
      this.loading.logs = true
      expense
        .getLogs(this.expense_id)
        .then((response) => {
          this.logs = response.data.logs
          this.loading.logs = false
        })
        .catch((response) => {
          this.loading.logs = false
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
        })
    },
    apportionmentOpen() {
      this.apportionment = true
      this.aptAmountValidate = false
      this.aptPercentValidate = false
      this.aptClientValidate = false
      this.aptClientRepet = false
      this.aptCategory = ''
      this.apportionments = new Array()
      this.apportionments = [
        {
          client: '',
          amount: 0.0,
          percent: 0.0,
        },
        {
          client: '',
          amount: 0.0,
          percent: 0.0,
        },
      ]

      this.aptTotal = 0.0
      this.aptPercent = 0.0
    },
    apportionmentSave() {
      let totalAmount = 0.0
      let totalPercent = 0.0

      this.aptClientValidate = false
      this.aptClientRepet = false

      for (let i = 0; i < this.apportionments.length; i++) {
        totalAmount += parseFloat(this.apportionments[i].amount)
        totalPercent += parseFloat(this.apportionments[i].percent)

        for (let j = i + 1; j < this.apportionments.length; j++) {
          if (this.apportionments[i].client == this.apportionments[j].client) {
            this.aptClientRepet = true
          }
        }
        if (
          this.apportionments[i].client == null ||
          this.apportionments[i].client == ''
        ) {
          this.aptClientValidate = true
        }
      }
      if (totalPercent != 100 || totalPercent < 99.9999) {
        this.aptPercentValidate = true
      } else {
        this.aptPercentValidate = false
      }
      if (
        totalAmount.toFixed(4) + 0.00001 >= this.expense.Total &&
        totalAmount.toFixed(4) - 0.00001 <= this.expense.Total
      ) {
        this.aptAmountValidate = false
      } else {
        this.aptAmountValidate = true
      }
      if (this.aptCategory != '') {
        this.aptCategoryValidate = false
      } else {
        this.aptCategoryValidate = true
      }

      if (
        this.aptAmountValidate == false &&
        this.aptPercentValidate == false &&
        this.aptClientValidate == false &&
        this.aptClientRepet == false &&
        this.aptCategoryValidate == false
      ) {
        this.loading.expense = true
        expense
          .apportionmentSave({
            expense_id: this.expense_id,
            category: this.aptCategory,
            apportionments: this.apportionments,
          })
          .then((res) => {
            this.$vs.notify({
              color: 'success',
              title: 'Success',
              text: 'Expense Apportionment',
            })
            this.loading.expense = false
            this.getExpense()
            this.$emit('refresh-table')
          })
          .catch((err) => {
            this.loading.expense = false
            this.displayErrors(err)
          })

        this.apportionment = false
        this.apportionments = []
      }
    },
    findDuplicates(arr) {
      let clients = []
      arr.forEach((element) => {
        clients.push({
          client: element.client,
        })
      })
      return arr.filter(
        (currentValue, currentIndex) =>
          clients.indexOf(currentValue) !== currentIndex
      )
    },
    addClientApportionment() {
      this.apportionments.push({
        client: '',
        amount: 0,
        percent: 0,
      })
    },
    deleteClientApportionment(index) {
      this.apportionments.splice(index, 1)
    },
    apoortionmentChangeValues(data) {
      this.apportionments[data.index].client = data.client
      this.apportionments[data.index].amount = data.amount
      this.apportionments[data.index].percent = data.percent

      this.aptTotal = 0.0
      this.aptPercent = 0.0
      this.apportionments.forEach((element) => {
        this.aptTotal += element.amount
        this.aptPercent += element.percent
      })
    },
    getDepartaments() {
      this.loading.departaments = true
      expense
        .getDepartaments()
        .then((response) => {
          this.departaments = [...response.data]
          this.loading.departaments = false
        })
        .catch((error) => {
          this.loading.departaments = false
          this.showValidationErrors(error)
        })
    },
  },
}
</script>

<style>
.font-18 {
  font-size: 18px;
}
.black-color {
  color: black;
}

.text-custom {
  color: black;
  font-size: 14px;
  font-weight: bold;
}

.con-vs-dialog {
  z-index: 99999;
}
/* .select-custom > .vs__dropdown-menu {
   max-height:200px;
} */
.con-vs-popup .vs-popup {
  top: 30px;
  position: absolute;
}
</style>
